import { computed } from 'vue'
import {useStore} from 'vuex'

export default {
    name: "NoSearchResults",
    props: {
        guids: {
            type: Array,
            required: true
        }
    },
    setup(props){
        const store = useStore()

        const getLabel = (labelKey) => store.getters['labels/getLabel']({ labelCollection: "noResults", labelKey: labelKey })
        
        const totalCount = computed(() => {
            return props.guids.reduce((sum, guid) => sum + store.state.search.scoped_total[guid], 0)
        })


        return {
            totalCount,
            getLabel
        }
    }
}